import React from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '../../../../application/store';

import { BookedForSalesEvents, BookedForSalesProduct, Customer, CustomerFacility, OrderSummary } from '../../../../api-client';

import BVCustomersEventRecap from './components/BVCustomerEventRecap/bv-customer-event-recap';
import BVCustomerView from './components/BVCustomerView/bv-customer-view';

import './bv-orders-group.scss';

interface IBVOrdersGroup {
    customer?: Customer;
    customerLoading: boolean;
    facilities?: CustomerFacility[];
    facilitiesLoading: boolean;
    orders?: OrderSummary[];
    ordersLoading: boolean;
    customersSummaryByFiltersLoading: boolean;
    bookedForSalesProducts?: BookedForSalesProduct[];
    bookedForSalesProductsLoading: boolean;
    customerBookedForSalesEventRecap?: BookedForSalesEvents;
    customerBookedForSalesEventRecapLoading: boolean;
    refreshBookedForSales: () => void;
}

const BVOrdersGroup: React.FunctionComponent<IBVOrdersGroup> = (props) => {
    const showEventFilter = useSelector(
        (state: RootState) => state.eventFilter.showEventFilter
    );

    return (
        <div className="bv-orders-group-container">
            {showEventFilter
                ? <BVCustomersEventRecap
                    facilities={props.facilities}
                    customer={props.customer}
                    bookedForSalesProducts={props.bookedForSalesProducts}
                    bookedForSalesProductsLoading={props.bookedForSalesProductsLoading}
                    customerBookedForSalesEventRecap={props.customerBookedForSalesEventRecap}
                    customerBookedForSalesEventRecapLoading={props.customerBookedForSalesEventRecapLoading}
                    refreshBookedForSales={props.refreshBookedForSales}
                />
                : <BVCustomerView {...props} />}
        </div>
    );
}

export default BVOrdersGroup;